import React from 'react'
import { Box, Container } from '@mui/material'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useSectionMetaData } from '@v4/components/common/SectionItem'
import { CONTENT_VARIANTS } from '../Sections.const'

const Content = ({ variant = CONTENT_VARIANTS.VARIANT_1, Element }) => {
	const metaData = useSectionMetaData()

	return (
		<Box className={clsx(variant, 'section-content')}>
			<Container className="section-content-content">{Element && <Element metaData={metaData} />}</Container>
		</Box>
	)
}

Content.propTypes = {
	variant: PropTypes.oneOf(Object.values(CONTENT_VARIANTS)),
	Element: PropTypes.elementType,
}

export default Content
